export const MIN_TABLE_ROW_HEIGHT = '68px';
